import { useState } from 'react'

import { Address } from 'Geo/types'
import { useBrasilAPI } from 'hooks/useBrasilAPI'

export default function useGetAddressByCEP() {
  const [loadingAddress, setLoadingAddress] = useState<boolean>(false)
  const [address, setAddress] = useState<Address>({})
  const [addressError, setAddressError] = useState<string>('')

  const { getBrasilAPIAddressByCEP } = useBrasilAPI()

  async function handleGetAddressByCEP(cep: string): Promise<{ address: Address; addressError: string }> {
    setLoadingAddress(true)
    try {
      const address = await getBrasilAPIAddressByCEP(cep)

      if (address.cep) {
        setAddress(address)
        setAddressError('')
      } else {
        setAddress({})
        setAddressError(address.message)
      }
      setLoadingAddress(false)
      return { address, addressError: address.message || '' }
    } catch (error: any) {
      setAddress({})
      setAddressError(error?.message)
      setLoadingAddress(false)
      return { address, addressError: error.message }
    }
  }

  return { addressError, address, setAddress, loadingAddress, handleGetAddressByCEP }
}
